<template>
	<div class="current-font">
	    <brand-menu></brand-menu>
      <b-container fluid>
        <checkout-header title="Payment">
          <div>
            <!-- <span class="title-letter">P</span>
            <span style="margin-left:-8px;">AYMENT</span> -->
            Payment
          </div>
        </checkout-header>
        <div class="container-body">
          <b-row class="contact-content">
            <b-col class="mr-4">
              <div class="">
                <div class="contact">Payment</div>
                <div class="line-body">
                  <div class="triangle-left"></div>
                  <div class="line"></div>
                  <div class="triangle-right"></div>
                </div>
                <div class="form-body">
                  <div>Please choose your payment method</div>
                  <div>
                    <b-card no-body class="payment">
                      <b-tabs v-model="form.payment.method" card>
                        <b-tab title="visa" :title-link-class="paymentLinkClass(0)">
                          <template #title>
                            <div><img :src="require('@/assets/xh/images/visa.png')" alt=""></div>
                          </template>
                          <div class="payment-body pt-2">
                            <b-form-group
                            	id="input-group-21"
                            	label="Card number*"
                            	labelClass="text-left"
                            	label-for="input-21"
                            >
                            	<b-form-input
                            		id="input-21"
                            		v-model="form.payment.info.cardNumber"
                            		type="number"
                            		placeholder=""
                            		required
                            	></b-form-input>
                            </b-form-group>
                          </div>
                          <div class="payment-body pt-2">
                            <div>
                              <label>Expiry date*</label>
                            </div>
                            <b-row class="form-group">
                              <b-col>
                                <b-form-select
                                	v-model="form.payment.info.month"
                                	:options="months"
                                ></b-form-select>
                              </b-col>
                              <b-col>
                                <b-form-select
                                	v-model="form.payment.info.year"
                                	:options="years"
                                ></b-form-select>
                              </b-col>
                            </b-row>
                          </div>
                          <div class="payment-body pt-2">
                            <b-row>
                              <b-col cols="3">
                                <b-form-group
                                	id="input-group-22"
                                	label="Security code*"
                                	labelClass="text-left"
                                	label-for="input-22"
                                >
                                  <template #label>
                                    Security code*
                                    <span class="ml-1" v-b-popover.hover.bottom="'Popover!'">
                                      <b-icon icon="info-circle-fill" aria-hidden="true"></b-icon>
                                    </span>
                                  </template>
                                	<b-form-input
                                		id="input-22"
                                		v-model="form.payment.info.securityCode"
                                		type="text"
                                		placeholder=""
                                		required
                                	></b-form-input>
                                </b-form-group>
                              </b-col>
                              <b-col cols="9"></b-col>
                            </b-row>
                          </div>
                        </b-tab>
                        <b-tab title="union-pay" :title-link-class="paymentLinkClass(1)">
                          <template #title>
                            <div><img :src="require('@/assets/xh/images/union-pay.png')" alt=""></div>
                          </template>
                          <b-card-text class="payment-body">
                            Click the button below to be directed to the selected payment method website to make this payment
                          </b-card-text>
                        </b-tab>
                        <b-tab title="paypal" :title-link-class="paymentLinkClass(2)">
                          <template #title>
                            <div><img :src="require('@/assets/xh/images/paypal.png')" alt=""></div>
                          </template>
                          <b-card-text class="payment-body">
                            After clicking "Pay with PayPal" a pop-up will appear asking you to log in to your PayPal account.
                            Review your payment and shipping details to complete your purchase.
                            You will be redirected to the "Breitling" Order Confirmation page afterwards.
                          </b-card-text>
                        </b-tab>
                        <b-tab title="alipay" :title-link-class="paymentLinkClass(3)">
                          <template #title>
                            <div><img :src="require('@/assets/xh/images/alipay.png')" alt=""></div>
                          </template>
                          <b-card-text class="payment-body">
                            Click the button below to be directed to the selected payment method website to make this payment
                          </b-card-text>
                        </b-tab>
                        <b-tab title="bank" :title-link-class="paymentLinkClass(4)">
                          <template #title>
                            <div><img :src="require('@/assets/xh/images/bank.png')" alt=""></div>
                          </template>
                          <b-card-text class="payment-body">
                            Click the button below to be directed to the selected payment method website to make this payment
                            Use a bank transfer to complete your order. Once your order is received you will be provided with
                            the bank account details to transfer the funds.
                          </b-card-text>
                        </b-tab>
                      </b-tabs>
                    </b-card>
                  </div>
                </div>
              </div>
            </b-col>
            <b-col class="mr-4">
              <div class="">
                <div class="contact">Billing Summary</div>
                <div class="line-body">
                  <div class="triangle-left"></div>
                  <div class="line"></div>
                  <div class="triangle-right"></div>
                </div>
                <div class="inner-line">
                  <div class="total-price mt-2">
                    <div>Total</div>
                    <div>
                      HK$ {{subtotal | formatPrice}}.
                      <span class="decimal">00</span>
                    </div>
                  </div>
                </div>
                <div class="inner-line">
                  <div class="total-price">
                    <div>Shipping Cost</div>
                    <div>
                      HK$ {{freightPrice | formatPrice}}.
                      <span class="decimal">00</span>
                    </div>
                  </div>
                </div>
                <div class="inner-line">
                  <div class="total-price">
                    <div>VAT/GST</div>
                    <div>
                      HK$ 0.
                      <span class="decimal">00</span>
                    </div>
                  </div>
                </div>
                <div class="total-summary">
                  <div class="total-summary-price font-weight-bold">
                    <div>Total for your order</div>
                    <div class="final-price">
                      HK$ {{totalPrice | formatPrice}}.
                      <span class="decimal">00</span>
                    </div>
                  </div>
                  <div class="total-summary-price">
                    <div>In the payment currency</div>
                    <div class="font-weight-bold">
                      ≈US$ {{usPrice | formatPrice}}.
                      <span class="decimal">00</span>
                    </div>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
          <div class="submit-body">
            <b-row>
              <b-col cols="3">
                <b-button variant="dark" block @click="handleSubmit()">SUBMIT</b-button>
              </b-col>
              <b-col cols="9"></b-col>
            </b-row>
          </div>
        </div>
      </b-container>
  </div>
</template>

<script>
import BrandMenu from "@/components/BrandMenu";
import CheckoutHeader from "@/components/CheckoutHeader";
import {queryCarByUserId} from '@/api/checkOut';
import {payMent} from '@/api/payMent';
export default {
  name: "PaymentView",
  components: {
    BrandMenu,
    CheckoutHeader
  },
  data() {
    return {
      userId:undefined,
      freightPrice:undefined,
      usPrice:undefined,
      subtotal:undefined,
      totalPrice:undefined,
      form: {
        payment: {
          method: 0,
          info: {
            cardNumber: undefined,
            expiryDateMonth: undefined,
            expiryDateYear: undefined,
            securityCode: undefined,
          }
        },
      },
      months: [
        {value: 1, text: '01'},
        {value: 2, text: '02'},
        {value: 3, text: '03'},
        {value: 4, text: '04'},
        {value: 5, text: '05'},
        {value: 6, text: '06'},
        {value: 7, text: '07'},
        {value: 8, text: '08'},
        {value: 9, text: '09'},
        {value: 10, text: '10'},
        {value: 11, text: '11'},
        {value: 12, text: '12'},
      ],
      years: [

      ]
    }
  },
  created() {
    if(!this.$store.getters.userId){
      this.$router.push('/login')
      return
    } else {
      this.userId = this.$store.getters.userId
      let orderid = this.$route.params.id
      let orderSn = this.$route.params.orderSn
      console.log('orderid:', orderid);
      let curYear = (new Date()).getFullYear()
      let year = curYear-2000
      for (let i=year; i<year+11; i++) {
        let tmp = {}
        tmp.value = i
        tmp.text = i + '';
        this.years.push(tmp);
      }
      queryCarByUserId(this.userId).then(response=>{
        console.log(response.data.data)
        this.payGoodList=response.data.data.goodsCarList
        this.subtotal=response.data.data.webPrice
        this.usPrice=response.data.data.usPrice
        this.freightPrice=response.data.data.freightPrice
        this.totalPrice=response.data.data.totalPrice
      })
    }
  },
  methods: {
    paymentLinkClass(idx) {
      if (this.form.payment.method == idx) {
        return ['payment-title-link'];
      } else {
        return ['payment-title'];
      }
    },
    handleSubmit(event) {
      let userId=this.$route.params.userId
      let orderSn = this.$route.params.orderSn
        console.log(event);
        payMent(userId,orderSn).then(response=>{
          this.$message.success('支付成功')
          this.$router.push({
            name: 'result',
            params: {
              type: 'success',
              title: 'Payment Successful',
              link: 'CHECK MY ORDERS',
              linkUrl: {name: 'user', query: {current: 'user-myPurchase'}},
              next: 'BACK',
              nextUrl: {path: '/'},
            }
          })
      }).catch(error => {
          this.$router.push({
            name: 'result',
            params: {
              type: 'fail',
              title: 'Payment Failed',
              link: 'NEED HELP? CONTACT US NOW',
              next: 'TRY AGAIN',
            }
          })
          this.$message.error('失败:' + error.data.errmsg)
        })
    }
  }
}
</script>

<style scoped>
  .current-font {
    font-family: SourceHanSansCN-ExtraLight;
    font-weight: 250;
  }
  input, select {
    font-family: SourceHanSansCN-ExtraLight;
    font-weight: normal;
  }
  .title-letter {
    font-size: 32px;
  }
  .container-body {
    padding: 5rem 5.5rem 6rem 5.5rem;
  }
  .contact-content {
  	margin: 0 1rem;
  }
  .contact-content .form-body {
    padding: 2rem 2rem;
  }
  .contact-content .form-body input {
    border: 1px solid black;
  }
  .form-body #input-4, .form-body #input-14 {
    border: none;
  }
  .form-body .input-group {
    border: 1px solid black;
  }
  .form-body .custom-select {
		border: 1px solid black;
		background: #fff url("../../public/img/viawatch/icon/pull-bottom.png") no-repeat right 0.75rem center;
	}
  /* 前导深度替换样式 */
 .custom-radio .custom-control-label {
    padding-top: 3.5px;
  }
  .contact-content .contact {
  	display: flex;
  	justify-content: flex-start;
  	font-size: 24px;
    margin-bottom: 0.5rem;
  }
  .contact-content .line-body {
  	height: 1px;
  	display: flex;
  }
  .contact-content .line {
  	height: 1px;
  	background: black;
  	display: flex;
  	flex-basis: 100%;
  	margin-top: 4.4px;
  	margin-left: -8px;
  	margin-right: -8px;
  }
  .contact-content .triangle-left {
  	width: 0;
  	height: 0;
  	border: 5px solid;
  	border-color: transparent transparent transparent black;
  }
  .contact-content .triangle-right {
  	width: 0;
  	height: 0;
  	border: 5px solid;
  	border-color: transparent black transparent transparent;
  }

  .total-line {
    border-bottom: 1px solid black;
  }
  .total-content {
    padding: 2rem 0;
  }
  .total-content .brand {
    color: #072D79;
  }
  .total-content .name {
    font-size: 1.25rem;
    font-weight: bold;
  }
  .total-content .sku {
    color: #979797;
  }
  .decimal {
    font-weight: normal;
    font-size: 1rem;
    margin-top: 0.25rem;
  }
  .total-price {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 1.125rem;
    font-weight: bold;
    padding: 1rem 3rem;
  }
  .inner-line {
    border-bottom: 1px solid #969696;
  }
  .total-summary {
    padding: 4.25rem 3rem;
  }
  .total-summary .total-summary-price {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 1.25rem;
    margin-bottom: 0.6rem;
  }
  .total-summary .final-price {
    font-size: 1.5rem;
  }
  .promo {
    padding: 0 2.5rem;
    margin-bottom: 3rem;
    cursor: default;
  }
  .promo .promo-bg {
    height: 4.5rem;
    background-color: #E0E0E0;
    display: flex;
    align-items: center;
  }
  .promo .promo-body {
    padding-left: 2rem;
    font-size: 1.5rem;
  }
  >>> .promo .link {
    text-decoration: underline;
    cursor: pointer;
  }
  .payment {
    border: none;
  }
  >>> .payment .card-header {
    background-color: white;
    border-bottom: none;
  }
  >>> .payment .payment-title {
    padding: 0;
    margin: 0.25rem 0.75rem;
    border: 1px solid #5F5F5F;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
  >>> .payment .payment-title-link {
    padding: 0;
    margin: 0.25rem 0.75rem;
    border-color: #24385D;
    border: 2px solid #24385D;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
  >>> .nav-tabs .nav-link.active {
    border-color: #24385D #24385D #24385D #24385D;
  }
  .payment .payment-body {
    margin-left: -1.5rem;
    font-weight: 250;
  }

  .submit-body {
  	padding-top: 3.6rem;
  	font-size: 18px;
  }
  .submit-body .btn {
    font-family: SourceHanSansCN-ExtraLight;
  	font-size: 18px;
    font-weight: 250;
    background-color: black;
  }
</style>



// WEBPACK FOOTER //
// src/views/PaymentView.vue